<template>
  <div style="width: 100%">
    <van-image class="full_w" :src="require('@/images/emptyView.png')"></van-image>
  </div>
</template>

<script>

import Vue from 'vue';
import { Image } from 'vant';

export default {
  name: 'emptyView',
  data () {
    return {

    }
  },
  methods: {

  },
  components: {
    [Image.name]: Image,
  },

}
</script>

<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// src/components/page/home/emptyView.vue